export default __webpack_public_path__ + "static/media/ic2n.9edd158e.jpg";